import { gql } from "apollo-angular";

const ADD_CROSS= gql`
          mutation AddCross($fromProductId: Long!, $toProductId: Long!) {
            createCrossReference(
              addCrossReference: {
                fromProductId: $fromProductId
                toProductId: $toProductId
              }
            ) {
              id
              crossReferenceType
              crossReferenceDescription
            }
          }
        `;
        
export default ADD_CROSS;